import { Text3D, Html } from "@react-three/drei"
import { useManosStore } from './hooks'
import { useThree } from "@react-three/fiber";
import gsap from "gsap";
import { useEffect, useState,useRef } from "react";
import useSound from 'use-sound'
import { Button } from "@mui/material";


const InsertCoin = ({ isMobile }) => {
    const sfx = '/assets/sounds/synthweapon-003-40567.mp3'

    const [play] = useSound(sfx, { volume: 0.45 })
    const { camera } = useThree()
    const { setZoomArcade, setShowIframe } = useManosStore()
    const [enableWireframe, setEnableWireframe] = useState(true)
    
    const nameRef = useRef()

    const handleInsertCoin = () => {
        gsap.timeline({
            onComplete: () => {
                setTimeout(() => {
                    setZoomArcade(true)
                    setShowIframe(true)
                }, 400)
            }
        })
            .to(camera.position, { x: -0.45, y: 3, z: 0.6, duration: 2 }, 0)
            .to(camera.rotation, {
                duration: 2,
                y: -2 * (Math.PI / 8),
                z: -2 * Math.PI / 90 - 0.15,
            }, 0)
            .to(camera.position, { x: -0.45, y: 4.2, z: 0.6, duration: 2 }, 2)

    }

    if (isMobile)
        return <>
            <Text3D
                font={'./Pixeloid Mono_Regular.json'}
                size={0.35}
                position={[4.5, 7, 10]}
                rotation={[0, 0.8, 0]}
            >
                Manolis Makris
                <meshStandardMaterial />
            </Text3D>
            <Text3D
                font={'./Pixeloid Mono_Regular.json'}
                size={0.35}
                position={[4.5, 6.2, 10]}
                rotation={[0, 0.8, 0]}
            >
                {'<Developer/>'}
                <meshStandardMaterial />
            </Text3D>
            <Text3D
                font={'./Pixeloid Mono_Regular.json'}
                size={0.75}
                position={[1.25, -1, 9]}
                receiveShadow
                rotation={[0, 0.65, 0]}
                onClick={handleInsertCoin}
                onPointerEnter={() => {
                    play()
                }}
            >
                Insert Coin
                <meshStandardMaterial color={'#f0d000'} />
            </Text3D>
        </>

    return (
        <>
            <Text3D
                font={'./Pixeloid Mono_Regular.json'}
                size={isMobile ? 0.4 : 0.7}
                position={[1.5, 2, 10]}
                receiveShadow
                rotation={[0, 0.5, 0]}
                onClick={handleInsertCoin}
                onPointerEnter={() => {
                    setEnableWireframe(false)
                    play()
                    document.body.style.cursor = `pointer`
                }}
                onPointerLeave={() => {
                    setEnableWireframe(true)
                    document.body.style.cursor = `initial`
                }}
            >
                Insert Coin
                <meshStandardMaterial wireframe={enableWireframe} color={'#f0d000'} />
            </Text3D>
            <group 
            position={[-4, 4.5, 7]}
            ref={nameRef}
                rotation={[0, 0.8, 0]}>
                <Text3D
                    font={'./Pixeloid Mono_Regular.json'}
                    size={isMobile ? 0.02 : 0.3}
                >
                    Manolis Makris
                    <meshStandardMaterial />
                </Text3D>
                <Text3D
                    position={[0,-0.5,0]}
                    font={'./Pixeloid Mono_Regular.json'}
                    size={0.2}
                >
                    {'<Developer/>'}
                    <meshStandardMaterial />
                </Text3D>
            </group>
        </>
    )
}

export default InsertCoin